import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map'
import { JwtHelper, tokenNotExpired } from 'angular2-jwt';

import { Router } from '@angular/router';

@Injectable()
export class AuthService {

    loggedIn: boolean = false;

    jwtHelper: JwtHelper = new JwtHelper();

    constructor(private http: Http,
                private router: Router) {

    }

    login(username: string, password: string): Observable<boolean> {
        var body = {
            grant_type: 'password',
            username: username,
            password: password
        }

        return this.http.post('/token', body)
            .map((response: Response) => {
                let token = response.text();
                if (token) {
                    localStorage.setItem('token', token);                    
                    return true;
                } else {                    
                    return false;
                }
            })
    }

    isLoggedIn() {
        return tokenNotExpired();
    }

    logout() {
        localStorage.removeItem('token');
        this.router.navigate(['login']);
    }
}


// WEBPACK FOOTER //
// C:/Users/Willi/Source/Repos/Reservation01/scr/reservation.client/src/app/services/auth.service.ts